import { render, staticRenderFns } from "./promote-packages.vue?vue&type=template&id=4ea7be28"
import script from "./promote-packages.vue?vue&type=script&lang=ts"
export * from "./promote-packages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports